angular.module('ihestiaCommonDirectives')
  .directive('ihestiaCommonConfirmModal', [
    function() {
      return {
        templateUrl: 'ihestia-commondirectives-template-app/directives/confirm/confirmModal.tpl.html',
        controller: 'confirmModalCtrl',
        scope: true
      };
    }
  ]);